<ul class="breadcrumb-list">
  <li class="breadcrumb-list__item crumb type-body-sm fw-normal crumb--back">
    <button class="crumb__link" (click)="goBack()">Terug</button>
  </li>
  <li class="breadcrumb-list__item crumb type-body-sm fw-normal" *ngFor="let crumb of crumbs; let i = index">
    <a class="crumb__link" [routerLink]="crumb.routerLink" [queryParams]="crumb?.params" *ngIf="i !== crumbs.length - 1">
      {{ crumb.label }}
    </a>

    <span *ngIf="i === crumbs.length - 1">{{ crumb.label }}</span>

    <app-icon *ngIf="i !== crumbs.length - 1" class="crumb__seperator icon-xxxs" anchor="icon-chevron-right-xs"></app-icon>
  </li>
</ul>
